<template>
  <!-- <div class="boxall"> -->
  <!-- <div class="tit04">地图总览</div> -->
  <div class="mapbox">
    <div class="data">
      <div class="money">
        <div class="item-info">
          <div class="item-label">交易额</div>
          <div class="item-value">
            <span class="num num2">{{ money }}</span>
            <span class="unit">万元</span>
          </div>
        </div>
      </div>

      <div class="number">
        <div class="item-info">
          <div class="item-label">交易量</div>
          <div class="item-value">
            <span class="num num1">{{ number }}</span>
            <span class="unit">吨</span>
          </div>
        </div>
      </div>
    </div>

    <div class="map-img">
      <div class="bg-image"></div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
// import { getDashboardData } from '@/api/getData'
import { mapGetters } from 'vuex'

export default {
  name: 'CenterMap',

  data() {
    return {
      number: 0,
      money: 0,
      countTimer: null
    }
  },

  created() {
    this.startCountUpTimer()
  },

  computed: {
    ...mapGetters('dashboard', ['marketInfo']),

    numberTarget() {
      const { year_weight } = this.marketInfo
      if (!year_weight) return 0

      return +(year_weight / 2000).toFixed(1)
    },

    moneyTarget() {
      const { year_amount } = this.marketInfo
      if (!year_amount) return 0

      return +(year_amount / 10000).toFixed(1)
    }
  },

  // 监听 marketInfo，数据一进来就触发动画
  watch: {
    marketInfo: {
      immediate: true, // 如果数据已经在 store 里了，立刻触发
      handler(val) {
        if (val && val.year_amount) {
          this.countUp('money', this.moneyTarget, 4000)
          this.countUp('number', this.numberTarget, 4000)
        }
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.countTimer)
  },

  methods: {
    // 每30秒触发一次数字动画
    startCountUpTimer() {
      this.countTimer = setInterval(() => {
        this.countUp('money', this.moneyTarget, 5000)
        this.countUp('number', this.numberTarget, 5000)
      }, 30 * 1000)
    },

    countUp(key, target, duration = 2000) {
      const start = performance.now()
      const tick = now => {
        const elapsed = now - start
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 4)
        this[key] = +(eased * target).toFixed(2)
        if (progress < 1) requestAnimationFrame(tick)
        else this[key] = target
      }
      requestAnimationFrame(tick)
    }
  }
}
</script>

<style scoped>
.mapbox {
  height: 100%;
  padding: 16px;
}

.data {
  display: flex;
  justify-content: space-evenly;
  height: 12%;
}

.number .money {
  font-size: 70px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
  display: inline-block;
  width: 200px;
  text-align: right; /* 数字右对齐，视觉上更稳 */

  /* 
  background-image: url('../assets/images/bg_middle_center.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: calc(100% - 16px) calc(100% - 16px); */
}

/* 右侧文字区域 — 垂直居中 */
.item-info {
  /* flex: 1; */
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  padding-bottom: 4px;
}

/* 第一行：数字 + 单位 */
.item-value {
  display: flex;
  align-items: baseline;
  gap: 18px;
}

.num {
  font-size: 70px;
  font-weight: bold;
  color: #00cfff;
  font-family: ds-digitalnormal !important;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.num1 {
  min-width: 220px;
}

.num2 {
  min-width: 220px;
}

.unit {
  font-size: 28px;
  color: #7ecfea;
}

/* 第二行：描述 */
.item-label {
  font-size: 24px;
  color: #8fb8c8;
  display: flex;
  justify-content: right;
  align-items: flex-end;
  margin-bottom: 8px;
}

.map-img {
  height: 87%;
}

.bg-image {
  width: 100%;
  height: 100%;

  background: url('../assets/images/bg_middle_pic1.jpg') no-repeat center center;
  background-size: cover;
  border-radius: 12px;

  /* position: relative; */
}

.map-charts {
  height: 100%;
  width: 100%;
}
</style>
